var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 user-modal-password-reset-view px-2" },
    [
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200" }, [
          _vm._v(_vm._s(_vm._f("trans")("Reset Password"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-0" }, [
          _vm._v(
            _vm._s(
              _vm._f("trans")(
                "Reset the password you use to log into your account."
              )
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mb-4",
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.requestPasswordReset.apply(null, arguments)
            },
          },
        },
        [
          _c("TextInput", {
            attrs: {
              "data-user-modal-input-email": "",
              type: "email",
              name: "u_email",
              label: _vm._f("trans")("E-Mail"),
              icon: "far fa-envelope",
              disabled: _vm.isSubmitting,
              "has-error": _vm.emailError !== null,
              "current-error": _vm.emailError,
              "trim-input": true,
              autocomplete: "email",
            },
            on: { input: _vm.updateEmail },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
        attrs: {
          "data-user-modal-button-submit": "",
          icon: "fa fa-unlock-alt",
          text: _vm._f("trans")("Reset Password"),
          "is-state-loading": _vm.isSubmitting,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.requestPasswordReset.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm._f("trans")("Having trouble?")) +
            "\n        "
        ),
        _c(
          "a",
          {
            attrs: { "data-user-modal-link-help": "", href: "" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.goToHelpPage.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm._f("trans")("Get help")))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center mt-2" },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("trans")("Already have an account?")) +
              "\n        "
          ),
          _c(
            "RouterLink",
            {
              attrs: {
                "data-user-modal-link-login": "",
                to: { name: _vm.userModalRoute.LOGIN },
                disabled: _vm.isSubmitting,
                event: _vm.isSubmitting ? "" : "click",
                tag: "a",
              },
            },
            [_vm._v(_vm._s(_vm._f("trans")("Log in")) + "\n        ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mb-4 mt-4" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("trans")("Don't have an account yet?")) +
              "\n        "
          ),
          _c(
            "RouterLink",
            {
              attrs: {
                "data-user-modal-link-register": "",
                to: { name: _vm.userModalRoute.REGISTER },
                disabled: _vm.isSubmitting,
                event: _vm.isSubmitting ? "" : "click",
                tag: "a",
              },
            },
            [_vm._v(_vm._s(_vm._f("trans")("Sign up")) + "\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }